import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const FAQS = [{
  question: '¿Qué recibo al comprar SIC 360?',
  answer: 'Recibís el sistema completo de clases anuales de Sistemas de Información Contable, más 4 bonos exclusivos: Clases Salvavidas (Plan B Docente), Evaluaciones Listas con Rúbricas, Mapa Anual de Contenidos, y Banco de Ejemplos Explicados. Todo en formato digital para descargar inmediatamente.'
}, {
  question: '¿Cuándo me llega?',
  answer: 'El acceso es inmediato. Una vez confirmado el pago, recibís un email con las instrucciones para descargar todo el material. Podés empezar a usarlo en menos de 5 minutos.'
}, {
  question: '¿Cómo lo recibo?',
  answer: 'Todo el material es digital. Después de la compra, te enviamos un link de descarga a tu email. Podés guardar los archivos en tu computadora, tablet o celular, y acceder cuando quieras sin necesidad de internet.'
}, {
  question: '¿Es físico o digital?',
  answer: 'Es 100% digital. No hay envíos físicos. Esto te permite acceder al instante y llevarlo siempre con vos en cualquier dispositivo. Además, podés imprimirlo si preferís trabajar en papel.'
}, {
  question: '¿Necesito ser profesional?',
  answer: 'No necesitás ser contador ni tener título universitario. SIC 360 está diseñado para docentes de nivel secundario que dictan materias relacionadas con contabilidad, economía o administración. Si das clases de SIC, esto es para vos.'
}, {
  question: '¿Tengo acceso para siempre?',
  answer: 'Sí, el acceso es vitalicio. Una vez que descargás el material, es tuyo para siempre. No hay vencimientos, renovaciones ni pagos mensuales. Comprás una vez y lo usás todos los años que quieras.'
}, {
  question: '¿Qué hago si no me llega el acceso?',
  answer: 'Si no recibís el email en los próximos 10 minutos, revisá tu carpeta de spam. Si aún así no lo encontrás, escribinos a soporte y te lo reenviamos de inmediato. Siempre respondemos en menos de 24 horas.'
}, {
  question: '¿Es una compra segura?',
  answer: 'Totalmente segura. Usamos la plataforma de pago más confiable de Argentina, con encriptación SSL. Aceptamos todas las tarjetas y Mercado Pago. Además, tenés garantía de devolución de 7 días sin preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 bg-slate-50" data-id="element-15">
      <div className="max-w-4xl mx-auto px-4" data-id="element-16">
        {/* Heading */}
        <div className="text-center mb-12" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-18">
            Resolvé aquí tus DUDAS
          </h2>
          <p className="text-xl text-slate-600" data-id="element-19">
            Las preguntas más frecuentes sobre el pack
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4" data-id="element-20">
          {FAQS.map((faq, index) => <div key={index} className={`bg-white rounded-xl border-2 transition-all duration-200 overflow-hidden ${openIndex === index ? 'border-blue-500 shadow-lg' : 'border-slate-200 hover:border-slate-300'}`} data-id="element-21">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-slate-50 transition-colors" data-id="element-22">
                <span className="font-bold text-slate-900 text-lg pr-4" data-id="element-23">
                  {faq.question}
                </span>
                <ChevronDown className={`w-6 h-6 text-blue-600 flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-24" />
              </button>

              <div className={`transition-all duration-200 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-25">
                <div className="px-6 pb-5 text-slate-700 leading-relaxed" data-id="element-26">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}